import { GraphQLEnumType } from 'graphql'

export type OrganizationType = 'Freemium' | 'Restricted' | 'Standard'

export const organizationType = new GraphQLEnumType({
  name: 'OrganizationType',
  description: 'The type of Organization',
  values: {
    Freemium: {
      description:
        'An organization granted basic functionality with a predefined number of licenses'
    },
    Restricted: {
      description:
        'An organization with restricted functionality and no licenses'
    },
    Standard: {
      description:
        'An organization with unrestricted functionality and at least one license'
    }
  }
})
